<!-- BEGIN: Subheader -->
<div class="m-subheader ">
    <div class="d-flex align-items-center">
        <div class="mr-auto">
            <h3 class="m-subheader__title m-subheader__title--separator">Banners</h3>
            <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
                <li class="m-nav__item m-nav__item--home">
                    <a [routerLink]="''" class="m-nav__link m-nav__link--icon">
                        <i class="m-nav__link-icon la la-home"></i>
                    </a>
                </li>
                <li class="m-nav__separator">-</li>
                <li class="m-nav__item">
                    <a [routerLink]="'/banners'" class="m-nav__link">
                        <span class="m-nav__link-text">Banners</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>

<div class="m-content">
    <div class="row">
        <div class="col-md-12">
            <!--begin::Portlet-->
            <div class="m-portlet m-portlet--mobile">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div class="m-portlet__head-title">
                            <h3 class="m-portlet__head-text">
                                Banners
                            </h3>
                        </div>
                    </div>
                    <div class="m-portlet__head-tools">
                        <ul class="m-portlet__nav">
                            <li class="m-portlet__nav-item">
                                <a [routerLink]="['create']"
                                   class="btn btn-primary m-btn m-btn--pill m-btn--custom m-btn--icon m-btn--air">
                                    <span>
                                        <i class="la la-plus"></i>
                                        <span>Nuevo Banner</span>
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="m-portlet__body">
                    <div class="table-responsive">
                        <!--begin: Datatable -->
                        <table datatable [dtOptions]="dtOptions"
                               class="table table-striped- table-bordered table-hover table-checkable">
                            <thead>
                            <tr>
                                <th>Imagen principal</th>
                                <th>Imagen Móvil</th>
                                <th>Texto principal</th>
                                <th>Imagen secundaria</th>
                                <th>Texto secundario</th>
                                <th>Texto botón</th>
                                <th>Link botón</th>
                                <th>Estado</th>
                                <th>Acciones</th>
                            </tr>
                            </thead>
                            <tbody *ngIf="banners?.length != 0">
                            <tr *ngFor="let item of banners">
                                <td>
                                    <ng-container *ngIf="item.main_image">
                                        <img [src]="item.main_image_url" [alt]="item.main_text" class="img-fluid">
                                    </ng-container>
                                    <ng-container *ngIf="!item.main_image">No Cargada</ng-container>
                                </td>
                                <td>
                                    <ng-container *ngIf="item.mobile_image">
                                        <img [src]="item.mobile_image_url" [alt]="item.main_text" class="img-fluid">
                                    </ng-container>
                                    <ng-container *ngIf="!item.mobile_image">No Cargada</ng-container>
                                </td>
                                <td>{{ item.main_text }}</td>
                                <td>
                                    <ng-container *ngIf="item.secondary_image">
                                        <img [src]="item.secondary_image_url" [alt]="item.secondary_text" class="img-fluid">
                                    </ng-container>
                                    <ng-container *ngIf="!item.secondary_image">No Cargada</ng-container>
                                </td>
                                <td>{{ item.button_text }}</td>
                                <td>{{ item.link_text }}</td>
                                <td>{{ item.status_banner }}</td>
                                <td>
                                    <button [routerLink]="['edit', item.id]"
                                            class="m-portlet__nav-link btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill"
                                            title="Edit details">
                                        <i class="la la-edit"></i>
                                    </button>
                                    <button (click)="delete(item)"
                                            class="m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill"
                                            title="Delete"> <i class="la la-trash"></i> </button>
                                </td>
                            </tr>
                            </tbody>
                            <tbody *ngIf="banners?.length == 0">
                            <tr>
                                <td colspan="8" class="no-data-available">No data!</td>
                            </tr>
                            <tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
